import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import API_BASE_URL from "../config";

const getDefaultRoute = (activeRole, roles) => {
  if (activeRole === "ROLE_ADMIN" || roles.includes("ROLE_ADMIN")) return "/admindashboard";
  if (activeRole === "ROLE_MANAGER" || roles.includes("ROLE_MANAGER")) return "/managerdashboard";
  return "/empdashboard";
};

export default function AssetPermissionRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [allowed, setAllowed] = useState(false);
  const [checking, setChecking] = useState(true);
  const hasRedirected = useRef(false);
  const originalRolesRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    const verifyAccess = async () => {
      const token = localStorage.getItem("token");
      const employeeId = localStorage.getItem("employeeId");
      const activeRole = localStorage.getItem("activeRole") || "";
      const roles = JSON.parse(localStorage.getItem("roles") || "[]");
      const fallbackRoute = getDefaultRoute(activeRole, roles);

      if (!token) {
        if (!hasRedirected.current) {
          hasRedirected.current = true;
          navigate("/", { replace: true });
        }
        return;
      }

      if (roles.includes("ROLE_ADMIN")) {
        if (mounted) {
          setAllowed(true);
          setChecking(false);
        }
        return;
      }

      if (!employeeId) {
        if (!hasRedirected.current) {
          hasRedirected.current = true;
          toast.error("Unable to verify your permissions.");
          navigate(fallbackRoute, { replace: true });
        }
        return;
      }

      try {
        const res = await fetch(`${API_BASE_URL}/api/permissions/${employeeId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error("Permission lookup failed");

        const data = await res.json();
        const hasAssetPermission = Boolean(data?.pages?.asset_management);

        if (!mounted) return;

        // if (hasAssetPermission) {
        //   if (!roles.includes("ROLE_ADMIN")) {
        //     originalRolesRef.current = roles;
        //     localStorage.setItem("roles", JSON.stringify([...new Set([...roles, "ROLE_ADMIN"])]));
        //   }
        //   setAllowed(true);
        //   setChecking(false);
        //   return;
        // }

        // In AssetPermissionRoute — replace the hasAssetPermission block:
        if (hasAssetPermission) {
          // ✅ Don't touch localStorage roles at all
          setAllowed(true);
          setChecking(false);
          return;
        }

        if (!hasRedirected.current) {
          hasRedirected.current = true;
          toast.error("You do not have access to Asset Management.");
          navigate(fallbackRoute, {
            replace: true,
            state: { from: location.pathname },
          });
        }
      } catch (error) {
        if (!mounted) return;

        if (!hasRedirected.current) {
          hasRedirected.current = true;
          toast.error("Unable to verify Asset Management access.");
          navigate(fallbackRoute, {
            replace: true,
            state: { from: location.pathname },
          });
        }
      } finally {
        if (mounted) setChecking(false);
      }
    };

    verifyAccess();

    return () => {
      if (originalRolesRef.current) {
        localStorage.setItem("roles", JSON.stringify(originalRolesRef.current));
      }
      mounted = false;
    };
  }, [location.pathname, navigate]);

  if (checking) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f4f6fb" }}>
        <div style={{ fontSize: 14, color: "#64748b" }}>Checking asset access...</div>
      </div>
    );
  }

  return allowed ? children : null;
}
